export default __webpack_public_path__ + "static/logo128-4d90f25c041810bf4314cc9c0b14977c.png";